import {PAGES} from 'routing/constants';

export const findPage = (currentPath?: string | string[]) =>
    Object.entries(PAGES).find(([_, {path}]) => currentPath === path)?.[1];
